import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { VerifyService } from 'src/app/services/verify/verify.service';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { BuilderService } from 'src/app/services/builder/builder.service';

@Component({
    selector: 'xqnr-verify-code-form',
    templateUrl: './verify-code-form.component.pug',
    styleUrls: ['./verify-code-form.component.scss'],
    standalone: false
})
export class VerifyCodeFormComponent implements OnInit {
  @Output() verifyCodeSubmitSuccess = new EventEmitter();
  @Output() resendCode = new EventEmitter();

  codeReqLoading = false;
  showWrongCodeError = false;
  showUserThrottledError = false;
  showGenericError = false;

  verifyCodeForm = this.fb.group({
    num1: ['', [Validators.required, Validators.nullValidator, Validators.pattern('[0-9]')]],
    num2: ['', [Validators.required, Validators.nullValidator, Validators.pattern('[0-9]')]],
    num3: ['', [Validators.required, Validators.nullValidator, Validators.pattern('[0-9]')]],
    num4: ['', [Validators.required, Validators.nullValidator, Validators.pattern('[0-9]')]]
  });

  fa = {
    circleNotch: faCircleNotch
  };

  constructor(
    private fb: FormBuilder,
    private verify: VerifyService,
    private qs: QuestionnaireService,
    private builder: BuilderService
  ) {}

  ngOnInit() {
    // Focus the first code input
    setTimeout(() => this.focusFieldById('verifyCodeFormNum1'), 0);
  }

  focusFieldById(id: string) {
    document.getElementById(id).focus();
  }

  // Move focus to next code number automatically,
  // Only when a number is entered and field is valid,
  // (allows other key presses such as tab enter etc.)
  codeKeyup(event: any, fieldName: string, nextFocusElId: string, prevFocusElId?: string) {
    if (
      this.verifyCodeForm.controls[fieldName].valid &&
      parseInt(event.key, 10) <= 9 &&
      parseInt(event.key, 10) >= 0
    ) {
      setTimeout(() => this.focusFieldById(nextFocusElId), 0);
    }
  }

  handleResendCode() {
    this.verifyCodeForm.reset();
    this.resetErrors();
    this.resendCode.emit();
  }

  closeGenericAlert(e: any) {
    e.preventDefault();
    this.showGenericError = false;
  }

  resetErrors() {
    this.showUserThrottledError = false;
    this.showWrongCodeError = false;
    this.showGenericError = false;
  }

  submitCodeSuccess = () => {
    this.codeReqLoading = false;
    this.verifyCodeSubmitSuccess.emit();

    // reset
    this.handleResendCode();
  };

  submitCodeError = (err: any) => {
    this.codeReqLoading = false;

    this.resetErrors();

    if (err.error.reason.indexOf('N_FAILED_ATTEMPTS') >= 0)
      this.showUserThrottledError = true;
    else if (err.error.reason.indexOf('WRONG_TOKEN') >= 0)
      this.showWrongCodeError = true;
    else
      this.showGenericError = true;
  };

  submitCode() {
    if (this.verifyCodeForm.valid) {
      const code: any = (
        this.verifyCodeForm.controls.num1.value
        + this.verifyCodeForm.controls.num2.value
        + this.verifyCodeForm.controls.num3.value
        + this.verifyCodeForm.controls.num4.value
      );

      this.codeReqLoading = true;

      this.verify.submitEmailVerifyCode(code).subscribe(
        this.submitCodeSuccess,
        this.submitCodeError
      );
    }
  }
}
